// Both counts diff whole calendar days rather than milliseconds. The two
// operands do not always carry the same UTC offset — antd's picker hands
// extension-offer-form a local-mode value while a seeded start date carries a
// fixed one — so a span crossing a DST fall-back is an hour longer in
// milliseconds than the calendar says, and Math.ceil turned that into an extra
// week: a 13-week extension reported 14. A day diff truncates the hour away,
// which also makes these agnostic about which date library each operand came
// from, since neither library's day diff depends on the other's offset.
//
// That is also why this file imports no date library: the day diff is a method
// on whichever instance the caller passes, so there is no duration static left
// to pick a library for.
const WEEK_IN_DAYS = 7;

export function getLengthInWeeks(startDate, endDate) {
  const length = getLengthInWeeksValue(startDate, endDate);
  return pluralizeWeeksValue(length);
}

export function getLengthInWeeksValue(startDate, endDate) {
  return Math.ceil(endDate.diff(startDate, 'day') / WEEK_IN_DAYS);
}

export function getLengthInWeeksInclusiveValue(startDate, endDate) {
  const dayBeforeStartDate = startDate.clone().subtract(1, 'day');
  return Math.ceil(endDate.diff(dayBeforeStartDate, 'day') / WEEK_IN_DAYS);
}

export function pluralizeWeeksValue(length) {
  return `${length} week${length > 1 ? 's' : ''}`;
}
